<template>
  <nav class="sticky top-0 z-50 flex justify-center overflow-x-hidden divide-x-2 divide-black divide-opacity-25 bg-gradient-to-b from-gray-900 to-black text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl uppercase">
    <a class="hidden md:block flex-auto py-4 px-2 lg:px-4 text-center text-gray-200 hover:text-yellow-200 hover:bg-gray-900" href="#home" @click.prevent="scrollToHash('#home')">
      <span>
        <i class="fa fa-home" />
      </span>
    </a>
    <a class="flex-auto py-4 px-2 lg:px-4 text-center text-gray-200 hover:text-yellow-200 hover:bg-gray-900" v-for="(item, key) in menu" :key="key" :href="`#${key}`" @click.prevent="scrollToHash($event.currentTarget.hash)">
      <span class="sm:hidden">
        <i :class="item.icon" />
      </span>
      <span class="hidden font-bold sm:block">{{ item.name }}</span>
    </a>
    <div class="flex-auto py-4 px-2 lg:px-4 space-x-2 cursor-pointer text-center text-gray-200">
      <UiFlag class="opacity-25 hover:opacity-100" :class="{ 'opacity-100': locale === 'en' }" country="en" @click="setLocale('en')" />
      <UiFlag class="opacity-25 hover:opacity-100" :class="{ 'opacity-100': locale === 'ru' }" country="ru" @click="setLocale('ru')" />
    </div>
  </nav>
</template>

<script>
  import { onMounted, onUnmounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { menu } from '../store.js'

  export default {
    name: 'Navigation',
    setup() {
      const { locale } = useI18n()

      function scrollToHash(hash) {
        const $element = document.querySelector(hash)
        if ($element) {
          window.scroll({
            top: window.scrollY + $element.getClientRects()[0].top - 30,
            behavior: 'smooth',
          })
        }
      }

      function onHashChange() {
        scrollToHash(location.hash)
      }

      function setLocale(newLocale) {
        locale.value = newLocale
        localStorage.setItem('locale', newLocale)
      }

      onMounted(() => {
        if (location.hash) {
          setTimeout(() => {
            history.replaceState({}, '', '/')
          }, 1000)
        }
        window.addEventListener('hashchange', onHashChange)
      })

      onUnmounted(() => {
        window.removeEventListener('hashchange', onHashChange)
      })

      return { menu, scrollToHash, setLocale, locale }
    },
  }
</script>

<style></style>
